/* global Blockly */
import { getPagesFromContext } from "../../../v1/helpers";

function defineBlock(pages, context) {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField('display ')
                .appendField(new Blockly.FieldDropdown(pages), 'page')
                .appendField('in gridview window')
                .appendField(new Blockly.FieldWidgetsDropdown(context,'gridview', undefined, '- select -'), 'gridview');
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Display a page in a gridview');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#app-actions');
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            const page = block.getFieldValue('page').split('<<<>>>').slice(-1);
            const gridview = block.getFieldValue('gridview');
            return `Snap.gridview.displayPageInWindow('${gridview}', '${page}'); \n`;
        }
    }
}

const DisplayPageGridview = function (props) {
    let name = 'snap_action_display_page_in_gridview';
    DisplayPageGridview.blockName = name;
    let pages = getPagesFromContext(props.context).filter((page) => {
        return !['recordslisting', 'approvalslisting', 'webpage'].includes(page[2]);
    });

    if (pages.length === 0) {
        return null;
    }

    Blockly.Blocks[name] = defineBlock(pages, props.context);

    let generators = defineGenerators();

    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return (
        <block type={name}></block>
    );
};

export default DisplayPageGridview;
